import React from 'react';

import type { Presence } from '../state/store';

export interface PresenceToggleProps {
  presence: Presence;
  onChange: (next: Presence) => void;
  disabled: boolean;
}

const LABELS: Record<Presence, string> = { online: 'Online', offline: 'Offline', busy: 'En llamada' };

export function PresenceToggle({ presence, onChange, disabled }: PresenceToggleProps): React.JSX.Element {
  const next: Presence = presence === 'online' ? 'offline' : 'online';
  return (
    <button type="button" disabled={disabled} onClick={() => onChange(next)}>
      {LABELS[presence]}
    </button>
  );
}
